import React, { useState, useEffect, useRef } from 'react';
import { debugLog } from '../utils/debugLog';
import './DebugPanel.css';

export default function DebugPanel() {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState(() => debugLog.getEntries());
  const listRef = useRef(null);

  useEffect(() => {
    const unsub = debugLog.subscribe(() => {
      setEntries(debugLog.getEntries());
    });
    return unsub;
  }, []);

  useEffect(() => {
    if (open && listRef.current) listRef.current.scrollTop = 0;
  }, [open, entries]);

  const handleClear = () => {
    debugLog.clear();
    setEntries([]);
  };

  const fullUrl = (e) => {
    if (e.baseURL && e.url) return (e.baseURL + e.url).replace(/([^:]\/)\/+/g, '$1');
    return e.url || '';
  };

  return (
    <div className="debug-panel-wrap">
      <button
        type="button"
        className="debug-panel-toggle"
        onClick={() => setOpen((v) => !v)}
        title={open ? 'Свернуть дебаг' : 'Открыть дебаг'}
      >
        Дебаг {entries.length > 0 && <span className="debug-badge">{entries.length}</span>}
      </button>
      {open && (
        <div className="debug-panel">
          <div className="debug-panel-header">
            <span>Лог действий и API</span>
            <button type="button" className="debug-clear-btn" onClick={handleClear}>
              Очистить
            </button>
          </div>
          <div className="debug-panel-list" ref={listRef}>
            {[...entries].reverse().map((e) => (
              <div
                key={e.id}
                className={`debug-entry debug-entry--${e.type}${e.type === 'api_response' && e.status >= 400 ? ' debug-entry--error' : ''}`}
              >
                <span className="debug-entry-ts">{e.ts}</span>
                <span className="debug-entry-type">{e.type}</span>
                {e.type === 'user_action' && (
                  <div className="debug-entry-body">
                    <strong>{e.action}</strong>
                    {e.detail != null && e.detail !== '' && (
                      <pre>{typeof e.detail === 'object' ? JSON.stringify(e.detail, null, 2) : String(e.detail)}</pre>
                    )}
                  </div>
                )}
                {e.type === 'api_request' && (
                  <div className="debug-entry-body">
                    <div className="debug-entry-req">
                      <strong>{e.method}</strong> {fullUrl(e)}
                    </div>
                    {(e.data || e.params) && (
                      <pre className="debug-entry-pre">
                        {JSON.stringify(e.data || e.params, null, 2)}
                      </pre>
                    )}
                  </div>
                )}
                {e.type === 'api_response' && (
                  <div className="debug-entry-body">
                    <div className="debug-entry-req">
                      <strong>{e.status}</strong> {e.url}
                    </div>
                    <pre className="debug-entry-pre">
                      {JSON.stringify(e.data !== undefined ? e.data : e.error, null, 2)}
                    </pre>
                  </div>
                )}
              </div>
            ))}
            {entries.length === 0 && (
              <div className="debug-entry debug-entry--empty">Нет записей</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
